import { XlsxAdapter } from "../../adpters/XlsxAdapter/XlsxAdapter";

export class CompanyContactsImportSpreadSheetRead {
    XlsxAdapter = new XlsxAdapter();
    constructor() {}

    async execute({ file }) {
        if (!file) return [];
        const data = await this.processFile({ file });
        const companiesContacts = this.mountCompaniesContactsRows(data);
        return companiesContacts;
    }

    async processFile({ file }) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = (e) => {
                const _parseUint8ToCharCode = (arrayBuffer) => {
                    const charCodes = [];
                    const data = new Uint8Array(arrayBuffer);

                    for (let i = 0; i <= data.length; ++i) {
                        charCodes[i] = String.fromCharCode(data[i]);
                    }

                    return charCodes;
                };
                const charCodes = _parseUint8ToCharCode(fileReader.result);
                const bstr = charCodes.join("");
                const workbook = this.XlsxAdapter.read(bstr, {
                    type: "binary",
                    raw: true,
                    cellNF: true,
                    cellFormula: true,
                    cellStyles: true
                });
                const response = this.XlsxAdapter.sheetToJson(
                    workbook.Sheets.Dados,
                    {
                        header: 1,
                        blankrows: false
                    }
                );
                resolve(response);
            };
            fileReader.readAsArrayBuffer(file);
        });
    }

    mountCompaniesContactsRows(data) {
        const contactsData = data.slice(2);
        const companyContacts = [];
        for (const row of contactsData) {
            for (let i = 1; i <= 60; i += 6) {
                const _id = row[i];
                const name = row[i + 1];
                const whatsapp = row[i + 2];
                const email = row[i + 3];
                const nps = row[i + 4];
                const user = row[i + 5];
                if (name || whatsapp || email) {
                    companyContacts.push({
                        _id,
                        company: { _id: row[61], name: row[0] },
                        name,
                        whatsapp,
                        email,
                        nps,
                        user
                    });
                }
            }
        }
        return companyContacts;
    }
}
